import React from 'react';
import CommonWelcomeAdd from '../../../components/Welcome/CommonWelcomeAdd';

const WelcomeFastAdd = () => {
    return (
        <CommonWelcomeAdd
            pageName='Pazarlama > Teklifler > Antrepo Teklifleri > Hızlı Karşılama'
            isOut={false}
            isIn={false}
        />
    )
}

export default WelcomeFastAdd;